<template>
  <el-tooltip :content="breadcrumbFullText" :disabled="!breadcrumbFullText" effect="dark" placement="bottom">
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <el-breadcrumb-item v-for="(item,index) in levelList" v-if="item.meta.title" :key="item.path">
        <router-link v-if="index===0" :to="item.redirect||item.path">{{ item.meta.title }}</router-link>
        <span v-else class="no-redirect">{{ item.meta.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </el-tooltip>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null,
      obj: {
        beforeEnter: undefined,
        components: {},
        instances: {},
        matchAs: undefined,
        meta: {
          icon: 'setting',
          noCache: false,
          page_functions: null,
          title: '工具箱'
        },
        name: 'toolBox',
        parent: undefined,
        path: '/toolBox',
        props: {},
        redirect: 'noredirect',
        regex: /^\/toolBox(?:\/(?=$))?$/i
      }
    }
  },
  computed: {
    breadcrumbFullText() {
      if (!this.levelList || !this.levelList.length) {
        return ''
      }
      return this.levelList
        .filter(item => item.meta && item.meta.title)
        .map(item => item.meta.title)
        .join(' / ')
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      const { params } = this.$route
      let matched = this.$route.matched.filter(item => {
        if (item.name) {
          // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
          var toPath = pathToRegexp.compile(item.path)
          item.path = toPath(params)
          return true
        }
      })
      if (this.$route.name == 'GeneralQueryList') {
        this.obj = this.$route.matched[0]
      }
      if (this.$route.name == 'GeneralQuery') {
        const list = []
        let item = {}
        item = Object.assign({}, matched[0])
        item.path = this.$route.path
        item.meta.title = '报表查询-' + this.$route.query.function_name
        list[0] = Object.assign({}, this.obj)
        list[1] = Object.assign({}, item)
        matched = list
      }
      const first = matched[0]
      if (first && first.name.trim().toLocaleLowerCase() !== 'Dashboard'.toLocaleLowerCase()) {
        matched = [{ path: '/', name: 'dashboard', meta: { title: '首页' }}].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /deep/ .el-tooltip {
    display: block;
    width: 100%;
    min-width: 0;
  }

  .app-breadcrumb.el-breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;

    /deep/ .el-breadcrumb__item {
      float: none;
      flex-shrink: 0;
    }

    /deep/ .el-breadcrumb__separator {
      flex-shrink: 0;
    }

    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>
